var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBtn',_vm._g(_vm._b({attrs:{"color":"primary","depressed":""}},'VBtn',_vm.$attrs,false),_vm.$listeners),[_c('VIcon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" Zapisz ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }